//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters, mapMutations} from "vuex";

export default {
  name: "SummaryStep",

  data() {
    return {
      selectedAlg: null,
      modelTitle: null,
      description: null,
      algs: [],
    };
  },

  mounted() {
    this.getAlgorithms();
  },

  computed: {
    ...mapGetters(["newModel"]),

    predictions: function () {
      return this.newModel.selectedPredictionProperties || [];
    },

    basedOn: function () {
      return this.newModel.selectedFieldsProperties || [];
    }
  },

  watch: {
    modelTitle: function (newVal) {
      const tmpModel = Object.assign({}, this.newModel);
      tmpModel.name = newVal;
      this.setNewModel(tmpModel);
    },

    description: function (newVal) {
      const tmpModel = Object.assign({}, this.newModel);
      tmpModel.description = newVal;
      this.setNewModel(tmpModel);
    }
  },

  methods: {
    ...mapMutations({
      displayError: "displayError",
      setNewModel: "setNewModel"
    }),

    getAlgorithms() {
      var pp = this.$refs.nuxeoPP;
      pp.query = `SELECT * FROM Document WHERE ecm:primaryType = 'AI_Training_Algorithm' AND ecm:isTrashed = 0 AND ecm:isVersion = 0`;
      pp.params.queryParams = null;
      pp.fetch()
        .then(resp => this.algs = resp.entries)
        .catch(err => {
          this.displayError(err);
          return this.algs = [];
        });
    },

    _algorithmSelected(val) {
      let tmpModel = Object.assign({}, this.newModel);
      console.log("Algorithm selected", val);
      tmpModel.algorithm = val.uid;
      this.setNewModel(tmpModel);
    },

    _editStep(step) {
      this.$emit('editStep', step);
    }
  }
};
